export const isLocal = () => process.env.NODE_ENV === 'development'

export const isServer = () => typeof window === 'undefined'

export const isClient = () => typeof window !== 'undefined'

export const isTest = () => process.env.APP_ENV === 'test'

export const isDev = () =>
  [
    process.env.NEXT_PUBLIC_VERCEL_ENV,
    process.env.NODE_ENV,
    process.env.APP_ENV,
  ].includes('development')

export const isPreview = () =>
  [process.env.NEXT_PUBLIC_VERCEL_ENV, process.env.APP_ENV].includes('preview')

export const isProd = () =>
  [process.env.NEXT_PUBLIC_VERCEL_ENV, process.env.APP_ENV].includes(
    'production'
  )

export const getApiUrl = (headers: Headers) =>
  `${isDev() ? 'http' : 'https'}://${headers.get('host')}`

export const kPublicUrl = isDev()
  ? `http://${process.env.NEXT_PUBLIC_VERCEL_URL}`
  : `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`

export const kDeploymentUrl = () => {
  if (isDev()) {
    return 'http://localhost:3000'
  }

  if (isPreview()) {
    return 'https://swell-sable.vercel.app'
  }

  return 'https://my.rosebud.app'
}
